const userRole =  {
  TM_ADMIN: "tm_admin",
  SCHOOL_CHAMPION: "school_champion",
  DISTRICT_CHAMPION: "district_champion"
};

export default userRole;